import { useState, useEffect } from 'react';
import { getStudentLessonsSummary } from '../../../../services/StudentService';
import { useGetRemoteServiceWrapper } from '../../../hooks/RemoteServiceHooks';
import ObjectUtils from '../../../../utils/ObjectUtils';
import Logger from '../../../../utils/Logger';

export const usePrepareStudentLessonsSummary = () => {
  const {
    loading,
    callRemoteServiceWrapper,
  } = useGetRemoteServiceWrapper();

  const [studentLessonsSummary, setStudentLessonsSummary] = useState(null);
  const fetchStudentLessonsSummary = (timeout = 2000) => {
    /*
      Delay the call for 2 seconds
      There will be some users who will not have any celebrations enabled for
      them which means the moment they finish the lesson, they will come back to
      theme page or self select page and the data about their lesson completion
      will still be in progress on the server
    */
    const timer = ObjectUtils.setTimeout(async () => {
      try {
        await callRemoteServiceWrapper(async () => {
          const result = await getStudentLessonsSummary();
          setStudentLessonsSummary(result.data);
        });
      } catch (e) {
        Logger.logError(e);
      }
    }, timeout);

    return timer;
  };

  useEffect(() => {
    const timer = fetchStudentLessonsSummary();
    // eslint-disable-next-line react-hooks/exhaustive-deps

    return (() => { clearTimeout(timer); });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    lessonsSummaryLoading: loading,
    fetchStudentLessonsSummary,
    studentLessonsSummary,
  };
};
